export default __webpack_public_path__ + "static/media/le_touquetmini.bf8ad57a.jpg";